import brandUtils from './brandUtils';
import StringConstants from '../constants/StringConstants';

export default (brandName: string): string => {
  if (brandUtils.isZillow(brandName)) {
    return StringConstants.ZILLOW_INBOX_PAGE_HEAD_TITLE;
  } else if (brandUtils.isHotpads(brandName)) {
    return StringConstants.HOTPADS_INBOX_PAGE_HEAD_TITLE;
  } else {
    return StringConstants.INBOX_PAGE_HEAD_TITLE;
  }
};
